var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 92,
    viewBox: "0 0 104 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_401_42039)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 9C2 4.58172 5.58172 1 10 1H94C98.4183 1 102 4.58172 102 9V81C102 85.4183 98.4183 89 94 89H10C5.58172 89 2 85.4183 2 81V9Z",
    fill: "url(#paint0_linear_401_42039)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0026 18.333C66.7306 18.333 78.6693 30.2717 78.6693 44.9997C78.6693 59.7277 66.7306 71.6663 52.0026 71.6663C47.2901 71.674 42.6604 70.4268 38.5893 68.053L25.3466 71.6663L28.952 58.4183C26.5762 54.346 25.3281 49.7143 25.336 44.9997C25.336 30.2717 37.2746 18.333 52.0026 18.333ZM42.9146 32.4663L42.3813 32.4877C42.036 32.5087 41.6986 32.5994 41.3893 32.7543C41.1 32.9182 40.836 33.1229 40.6053 33.3623C40.2853 33.6637 40.104 33.925 39.9093 34.1783C38.923 35.4608 38.3919 37.0352 38.4 38.653C38.4053 39.9597 38.7466 41.2317 39.28 42.421C40.3706 44.8263 42.1653 47.373 44.5333 49.733C45.104 50.301 45.664 50.8717 46.2666 51.4023C49.209 53.9929 52.7153 55.8611 56.5066 56.8583L58.0213 57.0903C58.5146 57.117 59.008 57.0797 59.504 57.0557C60.2806 57.0156 61.0389 56.8053 61.7253 56.4397C62.0745 56.2598 62.4153 56.064 62.7466 55.853C62.7466 55.853 62.8613 55.7783 63.08 55.613C63.44 55.3463 63.6613 55.157 63.96 54.845C64.1813 54.6157 64.3733 54.3463 64.52 54.0397C64.728 53.605 64.936 52.7757 65.0213 52.085C65.0853 51.557 65.0666 51.269 65.0586 51.0903C65.048 50.805 64.8106 50.509 64.552 50.3837L63 49.6877C63 49.6877 60.68 48.677 59.2613 48.0317C59.1129 47.9669 58.9538 47.9298 58.792 47.9223C58.6095 47.9036 58.4252 47.9241 58.2513 47.9825C58.0774 48.041 57.9181 48.1359 57.784 48.261C57.7706 48.2557 57.592 48.4077 55.664 50.7437C55.5533 50.8924 55.4009 51.0048 55.2261 51.0665C55.0513 51.1282 54.8621 51.1365 54.6826 51.0903C54.5089 51.0438 54.3387 50.9849 54.1733 50.9143C53.8426 50.7757 53.728 50.7223 53.5013 50.6263C51.9708 49.9585 50.5538 49.0561 49.3013 47.9517C48.9653 47.6583 48.6533 47.3383 48.3333 47.029C47.2842 46.0243 46.3699 44.8877 45.6133 43.6477L45.456 43.3943C45.343 43.2241 45.2516 43.0405 45.184 42.8477C45.0826 42.4557 45.3466 42.141 45.3466 42.141C45.3466 42.141 45.9946 41.4317 46.296 41.0477C46.5893 40.6743 46.8373 40.3117 46.9973 40.053C47.312 39.5463 47.4106 39.0263 47.2453 38.6237C46.4986 36.7997 45.7253 34.9837 44.9306 33.181C44.7733 32.8237 44.3066 32.5677 43.8826 32.517C43.7386 32.501 43.5946 32.485 43.4506 32.4743C43.0925 32.4565 42.7337 32.4601 42.376 32.485L42.912 32.4637L42.9146 32.4663Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_401_42039",
    x: 0,
    y: 0,
    width: 104,
    height: 92,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_401_42039"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_401_42039",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_401_42039",
    x1: 52,
    y1: 79.8965,
    x2: 52,
    y2: 13.8965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9D0154"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA1855"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.5f29c73b962822c61471435a702a001f.svg";
export { ForwardRef as ReactComponent };